
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { useCurrency, currencies } from "@/contexts/CurrencyContext";

const CurrencySelector = () => {
  const { selectedCurrency, setSelectedCurrency } = useCurrency();

  const handleCurrencyChange = (currencyCode: string) => {
    const currency = currencies.find(c => c.code === currencyCode);
    if (currency) {
      setSelectedCurrency(currency);
    }
  };

  return (
    <div className="flex items-center space-x-3 mt-8 pt-4 border-t border-gray-200">
      <Label htmlFor="currency-select" className="text-sm font-medium text-gray-600">
        Currency Display:
      </Label>
      <Select value={selectedCurrency.code} onValueChange={handleCurrencyChange}>
        <SelectTrigger className="w-48">
          <SelectValue>
            {selectedCurrency.symbol} {selectedCurrency.code}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-60 bg-white z-50">
          {currencies.map((currency) => (
            <SelectItem key={currency.code} value={currency.code}>
              <div className="flex items-center justify-between w-full">
                <span>{currency.symbol} {currency.code}</span>
                <span className="text-xs text-gray-500 ml-2">{currency.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className="text-xs text-gray-500">
        (Display only - no conversion)
      </span>
    </div>
  );
};

export default CurrencySelector;
